var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pendant',{attrs:{"icon-url":_vm.iconUrl,"time":_vm.leftTime,"segments":2,"show-tooltip":false},on:{"click":_vm.handleEntrance,"countdown":_vm.handleCountdown,"countdown-end":_vm.handleCountdownEnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }